<template>
    <div class="home-page">
        <profile-component/>
        <div class="tiles">
            <router-link v-if="userIsZorgProfessional" :to="{ name: $routeName.CONNECT }" class="tile is-connect">
                Smartwatch
                <br/>Uitgeven
            </router-link>
            <router-link v-if="userIsZorgProfessional" :to="{ name: $routeName.SMARTWATCH_OVERVIEW }"
                         class="tile is-unconnect">
                Smartwatch
                <br/>Actief
            </router-link>
            <router-link v-if="userIsZorgProfessional | userIsBeheerder" :to="{ name: $routeName.ADMIN }" class="tile is-admin">
                Beheer
            </router-link>
            <router-link v-if="userIsZorgProfessional | userIsMeldkamerMedewerker" :to="{ name: $routeName.NOTIFICATIONS }" class="tile is-notifications">
                Alarmeringen
            </router-link>
        </div>
    </div>
</template>

<script>
    import ProfileComponent from '../components/profile.component.vue';
    import {Role} from '../utils/enums';

    export default {
        name: 'home-page',
        data() {
            return {
                menuItems: []
            }
        },
        components: {
            ProfileComponent
        },
        computed: {
            userIsMeldkamerMedewerker() {
                return this.$store.getters.getUserGroups.includes(Role.MELDKAMER_MEDEWERKER);
            },
            userIsZorgProfessional() {
                return this.$store.getters.getUserGroups.includes(Role.ZORG_PROFESSIONAL);
            },
            userIsBeheerder() {
                return this.$store.getters.getUserGroups.includes(Role.MILES_BEHEERDER);
            }
        }
    };
</script>

<style scoped lang="scss">
    .home-page {
        padding: 0 30px !important;
        background-image: url('../assets/backgrounds/background-small.svg');
        background-size: 100% auto;
        background-position: bottom;

        @include desktop {
            background-image: none;
        }
    }

    .profile-component {
        margin: 50px 0;
    }

    .tiles {
        display: flex;
        flex-wrap: wrap;
        background-color: $white;
        box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        overflow: hidden;

        @include desktop {
            background-color: transparent;
            box-shadow: none;
            border-radius: 0;
        }
    }

    .tile {
        width: 50%;
        height: 108px;
        font-size: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $gray-dark;
        text-align: center;
        padding-top: 30px;
        background-position-y: 20px;
        transition: all 0.3s ease;

        @include desktop {
            width: 14rem;
            height: 140px;
            background-color: $white;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            font-size: 1rem;
            margin-bottom: 2rem;
            margin-right: 2rem;

            &:last-child {
                margin-right: 0;
            }
        }

        &:active,
        &:hover {
            background-color: $primary;
            color: $white;

            &.is-connect,
            &.is-unconnect {
                background-image: url('../assets/icons/watch-white.svg');
            }

            &.is-follow {
                background-image: url('../assets/icons/location-white.svg');
            }

            &.is-settings {
                background-image: url('../assets/icons/map-white.svg');
            }

            &.is-admin {
                background-image: url('../assets/icons/profile-white.svg');
            }

            &.is-notifications {
                background-image: url('../assets/icons/alarm-white.svg');
            }
        }

        &.is-connect,
        &.is-unconnect {
            background-image: url('../assets/icons/watch-blue.svg');
        }

        &.is-follow {
            background-image: url('../assets/icons/location-blue.svg');
        }

        &.is-settings {
            background-image: url('../assets/icons/map-blue.svg');
        }

        &.is-admin {
            background-image: url('../assets/icons/profile-blue.svg');
        }

        &.is-notifications {
            background-image: url('../assets/icons/alarm-blue.svg');
        }
    }
</style>
